/**
 * API client for URL redirects
 */
import { API } from '../../../constants';
import { RedirectData, RedirectLookupResponse } from './types';

const getApiBaseUrl = () => '';
const API_PATH = `${API.VERSION}/redirects`;

export const redirectApi = {
  /**
   * List all redirects
   */
  async list(activeOnly = false) {
    const url = `${getApiBaseUrl()}${API_PATH}?active_only=${activeOnly}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch redirects');
    const data = await response.json();
    return RedirectData.fromApiResponseList(data);
  },

  /**
   * Look up a redirect by source path
   */
  async lookup(path) {
    const url = `${getApiBaseUrl()}${API_PATH}/lookup?path=${encodeURIComponent(path)}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to lookup redirect');
    const data = await response.json();
    return new RedirectLookupResponse(data);
  },

  /**
   * Get reserved path patterns
   */
  async getReservedPatterns() {
    const url = `${getApiBaseUrl()}${API_PATH}/reserved`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch reserved patterns');
    return response.json();
  },

  /**
   * Get a redirect by ID
   */
  async get(id) {
    const url = `${getApiBaseUrl()}${API_PATH}/${id}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch redirect');
    const data = await response.json();
    return RedirectData.fromApiResponse(data);
  },

  /**
   * Create a new redirect
   */
  async create(redirectData) {
    const url = `${getApiBaseUrl()}${API_PATH}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(redirectData)
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to create redirect');
    }
    const data = await response.json();
    return RedirectData.fromApiResponse(data);
  },

  /**
   * Update a redirect
   */
  async update(id, updates) {
    const url = `${getApiBaseUrl()}${API_PATH}/${id}`;
    const response = await fetch(url, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates)
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to update redirect');
    }
    const data = await response.json();
    return RedirectData.fromApiResponse(data);
  },

  /**
   * Delete a redirect
   */
  async delete(id) {
    const url = `${getApiBaseUrl()}${API_PATH}/${id}`;
    const response = await fetch(url, { method: 'DELETE' });
    if (!response.ok) throw new Error('Failed to delete redirect');
    return true;
  },

  /**
   * Toggle redirect active status
   */
  async toggle(id) {
    const url = `${getApiBaseUrl()}${API_PATH}/${id}/toggle`;
    const response = await fetch(url, { method: 'POST' });
    if (!response.ok) throw new Error('Failed to toggle redirect');
    const data = await response.json();
    return RedirectData.fromApiResponse(data);
  }
};

